var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('audio',{ref:"audio",staticStyle:{"display":"none"},attrs:{"controls":"","id":"newsAudio"}},[_c('source',{attrs:{"src":require("audios/news.mp3"),"type":"audio/mpeg"}})]),(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }